import axios from "axios";
import { API_BASE_URL } from "./Domain";
export const http = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: true,
});
